import pdfMake from "../pdfMakeConfig";
import logoK from "../kyrioscoB64";
import logoTK from "../transkyriosB64";
import logoSK from "../../assets/logos/SK02_B64";
import { formatFecha } from "../dateFormatter";

const COLOR_PRIMARIO_DEFAULT = '#0b3d91';

const TEMAS_POR_EMPRESA = {
  1: { logo: logoTK, color: '#0b3d91' },
  2: { logo: logoSK, color: '#8a1c1c' },
};

const ANCHO_PAGINA_LANDSCAPE = 841.89; // A4 landscape, en pt

export function exportarPDF({
  dtRef,
  data,
  rows,
  columns,
  nombreArchivo = 'documento.pdf',
  tituloArchivo = null,
  subTituloArchivo = null,
  idEmpresa = null,
  colorPrimario = null,
}) {

  const temaEmpresa = TEMAS_POR_EMPRESA[idEmpresa];
  const logo = temaEmpresa?.logo ?? logoK;
  const color = colorPrimario ?? temaEmpresa?.color ?? COLOR_PRIMARIO_DEFAULT;

  let headers = [];
  let body = [];
  let widths = [];

  if (Array.isArray(rows) && Array.isArray(columns) && columns.length) {
    headers = columns.map(c => c.header);
    widths = columns.map(c => c.width ?? '*');
    body = rows.map(r => columns.map(c => safeText(c.get ? c.get(r) : r[c.key])));
  }
  else {
    if (!dtRef?.current) {
      console.warn('DataTable ref no disponible y no se proporcionaron {rows, columns}.');
      return;
    }
    const cols = dtRef.current.props.children || [];
    const colsArray = Array.isArray(cols) ? cols : [cols];

    headers = colsArray
      .filter(col => col?.props?.header && (col?.props?.field || col?.props?.exportBody))
      .map(col => col.props.header);

    widths = Array(headers.length).fill('auto');

    body = (data || []).map(row =>
      colsArray
        .filter(col => col?.props?.header && (col?.props?.field || col?.props?.exportBody))
        .map(col => {
          if (col.props.exportBody) return safeText(col.props.exportBody(row));
          if (col.props.body && col.props.field) return safeText(row[col.props.field]);
          return safeText(row[col.props.field]);
        })
    );
  }

  const margenIzq = 20;
  const margenDer = 20;
  const anchoTabla = ANCHO_PAGINA_LANDSCAPE - margenIzq - margenDer;

  const fechaImpresion = formatFecha(new Date());
  const totalRegistros = body.length;

  const filaHeaders = headers.map((h) => ({
    text: h,
    bold: true,
    color: '#ffffff',
    fillColor: color,
    margin: [4, 6, 4, 6],
    fontSize: 9.5,
  }));

  const docDefinition = {
    pageOrientation: 'landscape',
    pageMargins: [20, 80, 20, 40],

    header: {
      stack: [
        {
          table: {
            widths: ['20%', '65%', '15%'],
            body: [[
              {
                stack: [{
                  image: logo,
                  width: 130,
                  alignment: 'left',
                  margin: [0, 6, 0, 0]
                }],
                alignment: 'center',
                margin: [50, 0, 30, 0]
              },
              {
                stack: [
                  {
                    text: tituloArchivo || '',
                    style: 'header',
                    margin: [0, 5, 0, 0],
                    color: '#222'
                  },
                  {
                    text: subTituloArchivo || '',
                    style: 'subheader',
                    margin: [0, 0, 0, 0],
                    color: '#666'
                  },
                ],
                alignment: 'center',
                margin: [0, 2, 0, 0]
              },
              {
                stack: [{ text: 'Fecha de impresión:' }, { text: fechaImpresion }],
                margin: [0, 6, 20, 8],
                color: '#666',
                alignment: 'center',
                fontSize: 10, style: 'subheader'
              }
            ]]
          },
          layout: 'noBorders',
        },
        {
          canvas: [{ type: 'rect', x: 0, y: 0, w: anchoTabla, h: 2, color }],
          margin: [20, 4, 0, 0],
        },
      ],
      margin: [0, 20, 0, 0]
    },

    footer: (currentPage, pageCount) => ({
      margin: [40, 0, 40, 0],
      columns: [
        { text: `${totalRegistros} registro${totalRegistros === 1 ? '' : 's'}`, fontSize: 9, color: '#999' },
        { text: `Página ${currentPage} de ${pageCount}`, alignment: 'right', fontSize: 9, color: '#999' },
      ]
    }),

    content: [
      {
        table: {
          headerRows: 1,
          dontBreakRows: true,
          widths,
          body: [filaHeaders, ...body],
        },
        layout: {
          hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length ? 0 : 0.5),
          vLineWidth: () => 0,
          hLineColor: () => '#e0e0e0',
          fillColor: (rowIndex) => {
            if (rowIndex === 0) return null;
            return rowIndex % 2 === 0 ? '#f7f8fa' : null;
          },
          paddingTop: () => 5,
          paddingBottom: () => 5,
          paddingLeft: () => 4,
          paddingRight: () => 4,
        },
      },
    ],

    styles: {
      header: { fontSize: 16, bold: true, margin: [0, 0, 0, 10] },
      subheader: { fontSize: 10 },
    },
    defaultStyle: {
      font: 'Roboto',
      fontSize: 9.5,
      noWrap: false,
    },
  };

  return pdfMake.createPdf(docDefinition).open();
}

function safeText(v) {
  if (v == null) return '';
  if (typeof v === 'object' && v.text !== undefined) return v;
  if (typeof v === 'string') return v;
  if (typeof v === 'number' || typeof v === 'boolean') return String(v);
  try { return JSON.stringify(v); } catch { return ''; }
}